import { SlSelect, SlOption } from '@shoelace-style/shoelace/dist/react'
import { langoptions } from '../../utils/constants'
import React, { useEffect, useState } from 'react'
import API from '../../services/api'
import TableLoader from '../../shared/TableLoader'
import { useDispatch } from 'react-redux'
import NoDataFound from '../../shared/NoDataFound'
import { SetComponentId } from "../../redux/counterSlice";



function MauDau() {
    const dispatch = useDispatch();
    dispatch(SetComponentId(51));
    const [currentLang, setCurrentLang] = useState('1')
    const [currentDate, setCurrentDate] = useState(new Date().toISOString()?.split('T')[0])
    const [mauDauData, setMauDauData] = useState([])
    const [loader, setLoader] = useState(false)

    const handleLanguageChange = (e) => {
        setCurrentLang(e.target.value)
    }
    const handleDateChange = (e) => {
        setCurrentDate(e.target.value)
    }
    const fetchData = async () => {
        setLoader(true)
        try {
            let res = await API({
                url: `/stats/mau-dau`,
                method: 'POST',
                responseType: 'json',
                data: {
                    language: currentLang,
                    date: currentDate
                }
            })
            if(res.code === 200) {
                setMauDauData(res.data)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        finally{
            setLoader(false)
        }
    }
    useEffect(() => {
        fetchData()
    }, [currentLang, currentDate])
  return (
   <>
    <h5>Maus-Daus</h5>

    <div className='d-flex gap-3 justify-end ml-auto items-end'>
            <SlSelect 
                label='Language' 
                onSlChange={handleLanguageChange}
                value={currentLang}
            >
                {langoptions.map((option) => (
                    <SlOption key={option.value} value={`${option.value}`}>
                        {option.label}
                    </SlOption>
                ))}
            </SlSelect>
            <div className=' w-40'>
                <input 
                    type='date' 
                    className='form-control'  
                    onChange={handleDateChange} 
                    value={currentDate}
                />
            </div>
    </div>
        <table className='table table-bordered mt-2'>
            <thead className='position-sticky top-0 bg-white z-10'>
                <tr>
                    <th>S.No</th>
                    <th>District</th>
                    <th>Mau</th>
                    <th>Dau</th>
                    <th>FlipCount</th>
                </tr>
            </thead>
                {loader ? <TableLoader colspan={5} /> :  mauDauData.length ? (
                    <tbody>
                        {mauDauData.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td className='capitalize'>{item.dist_name}</td>
                                <td>{item.mau}</td>
                                <td>{item.dau}</td>
                                <td>{item.views}</td>
                            </tr>
                        ))}
                    </tbody>
                ) : (
                    <NoDataFound  colspan={5}/>
                )}
            </table>
   </>
  )
}

export default MauDau

/**
 * MauDau Component
 * 
 * Purpose:
 * Displays Monthly Active Users (MAU) and Daily Active Users (DAU) statistics by district
 * 
 * Features:
 * - Language selection filter
 * - Date selection filter
 * - Tabular display of district-wise MAU/DAU data
 * 
 * Props: None
 * 
 * State:
 * - currentLang: Selected language filter
 * - currentDate: Selected date filter
 * - mauDauData: Array of MAU/DAU statistics
 * - loader: Loading state indicator
 * 
 * API Integration:
 * - Endpoint: /stats/mau-dau
 * - Method: POST
 * - Payload: {language, date}
 * 
 * Dependencies:
 * - @shoelace-style/shoelace
 * - Redux for component ID management
 * - Custom API service
 * - TableLoader and NoDataFound shared components
 * 
 * Table Structure:
 * - S.No: Index number
 * - District: Name of the district
 * - Mau: Monthly Active Users count
 * - Dau: Daily Active Users count
 */
